import * as TYPES from '../../types'
export default {}
